import { render, staticRenderFns } from "./ProgressWingComp.vue?vue&type=template&id=24dce7fd&scoped=true&"
import script from "./ProgressWingComp.vue?vue&type=script&lang=ts&"
export * from "./ProgressWingComp.vue?vue&type=script&lang=ts&"
import style0 from "./ProgressWingComp.vue?vue&type=style&index=0&id=24dce7fd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24dce7fd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAvatar,VTooltip})
